import { z } from 'zod';

export const emailSchema = (customMessages?: { email?: string; required?: string }) =>
  z
    .string()
    .email(customMessages?.email || 'Invalid email format')
    .min(1, customMessages?.required || 'Email is required');

export const phoneSchema = (customMessage?: string) =>
  z
    .string()
    .regex(
      /^(\+?1[-.\s]?)?\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/,
      customMessage || 'Invalid phone number format',
    );

export const zipCodeSchema = (customMessage?: string) =>
  z.string().regex(/^\d{5}(-\d{4})?$/, customMessage || 'Invalid ZIP code format');

export const stateSchema = (customMessages?: { length?: string; format?: string }) =>
  z
    .string()
    .length(2, customMessages?.length || 'State must be 2 characters')
    .regex(/^[A-Z]{2}$/, customMessages?.format || 'State must be uppercase letters');

export const nameSchema = (customMessages?: {
  required?: string;
  tooLong?: string;
  invalidChars?: string;
}) =>
  z
    .string()
    .min(1, customMessages?.required || 'Name is required')
    .max(100, customMessages?.tooLong || 'Name is too long')
    .regex(/^[a-zA-Z\s\-'.]+$/, customMessages?.invalidChars || 'Name contains invalid characters');

export const passwordSchema = (customMessages?: {
  tooShort?: string;
  tooLong?: string;
  complexity?: string;
}) =>
  z
    .string()
    .min(8, customMessages?.tooShort || 'Password must be at least 8 characters')
    .max(128, customMessages?.tooLong || 'Password is too long')
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      customMessages?.complexity ||
        'Password must contain at least one lowercase letter, one uppercase letter, and one number',
    );

export const urlSchema = (customMessage?: string) =>
  z.string().url(customMessage || 'Invalid URL format');

export const uuidSchema = (customMessage?: string) =>
  z.string().uuid(customMessage || 'Invalid UUID format');

export const requiredStringSchema = (customMessage?: string) =>
  z.string().min(1, customMessage || 'This field is required');

export const optionalStringSchema = z.string().optional();

export const positiveNumberSchema = (customMessage?: string) =>
  z.number().positive(customMessage || 'Number must be positive');

export const integerSchema = (customMessage?: string) =>
  z.number().int(customMessage || 'Number must be an integer');
